import { render } from "./AdministerTranslationSeo.vue?vue&type=template&id=18f45822"
import script from "./AdministerTranslationSeo.vue?vue&type=script&lang=js"
export * from "./AdministerTranslationSeo.vue?vue&type=script&lang=js"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__